import { PayloadAction } from "@reduxjs/toolkit";
import { takeLatest, all, put, call } from "redux-saga/effects";

import { commonMessages } from "infrastructure/localization";
import { notification } from "infrastructure/notification";

import { termTranslationsActions } from "./TermTranslations.actions";
import { getTermTranslations } from "./TermTranslations.api";
import { mergeTermWithTranslations } from "./TermTranslations.helpers";

function* loadTermTranslationsExecute(action: PayloadAction<{ termId: string; status: string }>) {
  try {
    const result = yield call(getTermTranslations, action.payload.termId, action.payload.status);

    yield put(termTranslationsActions.loadTermTranslationsCompleted(mergeTermWithTranslations(result)));
  } catch (e) {
    yield put(termTranslationsActions.loadTermTranslationsFailed(notification.error(e).useMessageId(commonMessages.error("searchFailed"))));
  }
}

function* actionWatcher() {
  yield takeLatest(termTranslationsActions.loadTermTranslations.toString(), loadTermTranslationsExecute);
}

export function* termTranslationsSaga() {
  yield all([actionWatcher()]);
}
